<template>
  <div>
    <el-backtop>
      <div class="btn"/>
    </el-backtop>
  </div>
</template>

<script>
export default {
}
</script>
<style scoped lang="scss">
  .btn{
    height: 100%;
    width: 100%;
    background:url("../../assets/pngs/scroll-top-top.png") no-repeat center center;
    background-size: 100%;
  }
  ::v-deep .el-backtop{
    top: 400px;
    z-index: 9999;
    width: 70px;
    height: 70px;
    box-shadow: none;
    border-radius: 0;
    background: transparent;
    &:hover {
      background-color: transparent;
    }
  }
</style>
